import header from "./bungalow-next-to-mountain.webp";
import section1 from "./bungalows.webp";
import section2 from "./bungalow-floor-plan.webp";
import section3 from "./ferienbungalow.webp";
import section4 from "./floor-plans-of-bungalows.webp";
import section5 from "./bungalow-in-forest.jpg";
import section6 from "./bungalow-near-lake.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
